<template>
  <div class="content">
    <MakeTransaction ref="makeTransaction"></MakeTransaction>

    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">Estado de Cuentas</h4>
                    <p class="card-category">Resumen</p>
                  </div>
                  <div class="button-group">
                    <button @click="makeTransaction" class="btn btn-primary">
                      Realizar traslado
                    </button>
                    <!--                    <button-->
                    <!--                      disabled-->
                    <!--                      class="btn btn-primary">-->
                    <!--                      Alta de AVL's-->
                    <!--                    </button>-->
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <b-tabs lazy>
                      <b-tab title="Efectivo">
                        <EstadoDeCuentasGrid
                          :row-data="cuentasEfectivo"
                          :column-defs="columnsEfectivo"
                        >
                        </EstadoDeCuentasGrid>
                      </b-tab>
                      <b-tab title="Cheques">
                        <EstadoDeCuentasGrid
                          :row-data="cuentasCheques"
                          :column-defs="columnsCheque"
                        >
                        </EstadoDeCuentasGrid>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EstadoDeCuentasGrid from "./EstadoDeCuentasGrid";
import { BTabs, BTab } from "bootstrap-vue";
import MakeTransaction from "@/pages/Cuentas/MakeTransaction";
import MoneyTotalComponent from "@/pages/Cuentas/Index/Tablas/MoneyTotalComponent";
import MoneyMontoComponent from "@/pages/Cuentas/Index/Tablas/MoneyMontoComponent";

export default {
  name: "EstadosDeCuentaTablas",
  components: { BTabs, BTab, EstadoDeCuentasGrid, MakeTransaction },
  data: () => ({
    mode: "efectivo",
  }),
  methods: {
    makeTransaction() {
      this.$refs.makeTransaction.$refs.modal.show();
    },
  },
  computed: {
    cuentasEfectivo() {
      return this.$store.getters["cuentas/getCuentasEfectivo"];
    },
    cuentasCheques() {
      return this.$store.getters["cuentas/getCuentasCheques"];
    },
    columnsCheque() {
      return [
        {
          headerName: "Ubicación",
          field: "ubicacion_cheque",
        },
        {
          headerName: "Monto",
          cellRendererFramework: MoneyTotalComponent,
          type: "rightAligned",
        },
        {
          headerName: "Tipo de Dinero",
          cellRenderer: () => "Cheque",
        },
      ];
    },
    columnsEfectivo() {
      return [
        {
          headerName: "Ubicación",
          field: "ubicacion",
        },
        {
          headerName: "Monto",
          cellRendererFramework: MoneyMontoComponent,
          type: "rightAligned",
        },
        {
          headerName: "Tipo de Dinero",
          field: "tipo_dinero",
        },
      ];
    },
  },
};
</script>

<style scoped></style>
